/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  message,
  Tabs,
  Card,
  DatePicker,
} from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import LecturaDeDocumento from 'components/LecturaDeDocumento/LecturaDeDocumento';
import { aplicarDomicilioExacto } from 'utils/domicilioLeido';
import { getCodigosPostales, getEstadosGlobales, getTiposDeVialidades } from 'api/catalogos/index';
import { checkToken } from 'api/utils';
import API from 'utils/api';
import { NOMBRES_PATTERN } from 'utils/patterns';
import ModalSearch from 'components/Direccion/ModalSearch';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import {
  autorizarConfiguracionExternaDescuento,
  deleteConfiguracionExternaDescuento,
  getConfiguracionExternaDescuento,
  getConfiguracionExternaDescuentos,
  patchConfiguracionExternaDescuento,
  postConfiguracionExternaDescuento,
} from 'api/catalogos/ConfiguracionCargaExternaDescuento';
import { getConceptosCargaExterna } from 'api/catalogos/ConceptosCargaExterna';
import { getModelPermission } from 'utils/permission';
import {
  autorizarDireccion,
  deleteDireccion, getDirecciones, patchDireccion, postDireccion,
} from 'api/catalogos/Direccion';
import { getTipoDirecciones } from 'api/catalogos/TiposDireccion';
import moment from 'moment';

export const empleadodomiciliosPermission = {
  permissionModel: 'empleadodomicilios',
  catalogsModels: [],
  tabsModels: [],
};
const { TabPane } = Tabs;

const Direcciones = ({
  formDireccion,
  rules,
  coloniasCargadas,
  paises,
  isBlocked,
  permission,
  empleadoId, // ← Agregado aquí
}) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [conceptosCargaExterna, setConceptosCargaExterna] = useState([]);
  const [pageActual, setPageActual] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [colonias, setColonias] = useState([]);
  const [visibleNoSeCodigo, setVisibleNoSeCodigo] = useState(false);
  const [tiposDeVialidades, setTiposDeVialidades] = useState([]);
  const [tiposDeDireccion, setTiposDeDireccion] = useState([]);

  const formInstances = [
    form,
  ];
  const fetchData = async () => {
    if (!empleadoId) return;

    setLoading(true);
    try {
      const response = await getDirecciones({ empleado: empleadoId });
      let { results } = response;

      // Ordenar: activos primero
      results = results.sort((a, b) => {
        // eslint-disable-next-line max-len
        if (a.estados_globales === ESTATUS_ACTIVO && b.estados_globales !== ESTATUS_ACTIVO) return -1;
        // eslint-disable-next-line max-len
        if (a.estados_globales !== ESTATUS_ACTIVO && b.estados_globales === ESTATUS_ACTIVO) return 1;
        return 0;
      });

      setData({ ...response, results });
    } catch (err) {
      onError(err);
    }
    setLoading(false);
  };

  //   const fetchConceptos = async () => {
  //     if (!conceptosCargaExterna.length) {
  //       const conceptos = await getConceptosCargaExterna();
  //       setConceptosCargaExterna(conceptos);

  //       // Aquí hacemos fetch de estados globales solo después de obtener los conceptos
  //       const _estados = await getEstadosGlobales();
  //       setEstados(_estados);
  //     }
  //   };
  const baseURI = '/estructura-organizacional/empleados-domicilios';
  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, '')); // solo dígitos
      const response = await API.get(baseURI, { params: { page: cleanPage, ...q } });

      const { results } = response.data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ...response.data, results });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const getFromPostalCode = (param, isInitialLoad = false) => {
    setTimeout(async () => {
      try {
        const _codigosPostales = await getCodigosPostales({ d_codigo: param });

        if (_codigosPostales.length) {
          const [firstItem] = _codigosPostales;
          const coloniasArr = _codigosPostales.map((item) => ({
            id: item.id,
            colonia: item.d_asenta,
          }));

          setColonias(coloniasArr);

          const estado = firstItem?.municipio?.estado?.nombre_de_AGEE || '';
          const municipio = firstItem?.municipio?.nom_mun || '';

          const commonValues = {
            pais_codigo_postal: 'México',
            estado,
            municipio,
          };
          // if (isInitialLoad && isEditing) {
          //   return;
          // }

          // Si es edición manual (el usuario está escribiendo el CP)
          if (isEditing) {
            formDireccion.setFieldsValue(commonValues);
            return;
          }

          // Lógica para registros NUEVOS
          if (_codigosPostales.length === 1) {
            formDireccion.setFieldsValue({
              ...commonValues,
              colonia: firstItem.d_asenta,
              codigo_postal: firstItem.id,
            });
          } else {
            message.info('Se encontraron varias colonias. Por favor seleccione una de la lista.');
            formDireccion.setFieldsValue({
              ...commonValues,
              colonia: null,
              codigo_postal: null,
            });
          }
        } else if (!isEditing) {
          message.info('No se encontró información relacionada al código postal brindado');
          formDireccion.setFieldsValue({
            pais_codigo_postal: 'México',
            codigo_postal: undefined,
            estado: undefined,
            municipio: undefined,
            colonia: undefined,
          });
          setColonias([]);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[Dirección] error al consultar colonias del código postal', err);
      }
    }, 300);
  };

  const onFinishSearch = async (values) => {
    if (values) {
      const _codigosPostales = await getCodigosPostales({ d_codigo: values.d_codigo });
      if (_codigosPostales.length) {
        const coloniasArr = _codigosPostales.map((item) => ({
          id: item.id, colonia: item.d_asenta,
        }));
        setColonias(coloniasArr);
        formDireccion.setFieldsValue({
          pais_codigo_postal: 'México',
          codigo_postal: values.id,
          colonia: values.d_asenta,
          d_codigo: values.d_codigo,
          estado: values.nombre_de_AGEE,
          municipio: values.municipio.nom_mun,
        });
      } else {
        message.warn('Seleccione un elemento');
      }
    }
  };

  const watchCP = Form.useWatch('d_codigo', formDireccion);

  useEffect(() => {
    const cargarColoniasEditar = async () => {
      if (open && isEditing) {
        const cp = formDireccion.getFieldValue('d_codigo');

        if (cp && cp.length === 5) {
          await getFromPostalCode(cp);
        }
      }
    };

    cargarColoniasEditar();
  }, [open, isEditing]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      if (!empleadoId) {
        setData({ count: 0, results: [] }); // Limpiar si no hay ID
        return;
      }

      setLoading(true);
      setData({ count: 0, results: [] }); // <-- IMPORTANTE: Limpiar antes de la nueva carga

      try {
        await checkToken();
        const [
          _tiposDeDireccion,
          _tiposDeVialidades,
          _estados,
          _data,
        ] = await Promise.all([
          getTipoDirecciones(),
          getTiposDeVialidades(),
          getEstadosGlobales(),
          getDirecciones({ empleado: empleadoId }), // ← Aquí filtras por empleado
        ]);
        if (mounted) {
          setTiposDeDireccion(_tiposDeDireccion);

          setTiposDeVialidades(_tiposDeVialidades);
          setEstados(_estados);
          let { results } = _data;

          results = results.sort((a, b) => {
          // eslint-disable-next-line max-len
            if (a.estados_globales === ESTATUS_ACTIVO && b.estados_globales !== ESTATUS_ACTIVO) return -1;
            // eslint-disable-next-line max-len
            if (a.estados_globales !== ESTATUS_ACTIVO && b.estados_globales === ESTATUS_ACTIVO) return 1;
            return 0;
          });
          setData({ ..._data, results });
          setLoading(false);
        }
      } catch (err) {
        onError(err);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, [empleadoId]);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
    formDireccion.resetFields();
    formDireccion.setFieldsValue({ vigencia_final: null });
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    try {
      const [key] = selectedRowKeys;

      // Buscar el registro seleccionado o usar el que viene por parámetro
      const match = responseData || data.results.find((item) => item.id === key);
      if (!match) {
        message.warn('No se encontró el registro seleccionado');
        return;
      }

      // Formatear datos recibidos del backend
      const formatted = formatReceived(match);

      // Convertir fecha a objeto moment (requerido por DatePicker)
      formatted.vigencia_final = match.vigencia_final
        ? moment(match.vigencia_final)
        : null;

      // Asignar tipo de dirección directamente (puede venir como objeto o ID)
      formatted.tipo_de_direccion = match.tipo_de_direccion.id;

      // Asignar tipos de vialidad correctamente
      formatted.tipo_de_vialidad = match.tipo_de_vialidad;
      formatted.tipo_de_vialidad_entre = match.tipo_de_vialidad_entre;
      formatted.tipo_de_vialidad_y_calle = match.tipo_de_vialidad_y_calle;

      // Asignar campos faltantes que no se estaban seteando
      formatted.calle_principal = match.calle_principal;
      formatted.entre_calle = match.entre_calle;
      formatted.y_calle = match.y_calle;
      formatted.numero_exterior = match.numero_exterior;
      formatted.numero_interior = match.numero_interior;
      formatted.descripcion_de_la_ubicacion = match.descripcion_de_la_ubicacion;

      // Si el código postal existe, extraer información relacionada
      if (match.codigo_postal) {
        formatted.d_codigo = match.codigo_postal.d_codigo;
        formatted.codigo_postal = match.codigo_postal.id;
        formatted.estado = match.codigo_postal?.municipio?.estado?.nombre_de_AGEE || '';
        formatted.municipio = match.codigo_postal?.municipio?.nom_mun || '';
        formatted.pais_codigo_postal = 'México';
        // Cargar la colonia como opción única si aplica
        const coloniaLabel = match.colonia ?? match.codigo_postal?.d_asenta ?? '';
        // if (coloniaLabel) {
        //   setColonias([{ id: 1, colonia: coloniaLabel }]);
        //   formatted.colonia = coloniaLabel;
        // }
      }

      // Cargar todos los datos en el formulario
      formDireccion.setFieldsValue(formatted);
      // Configurar el estado del formulario según el estatus
      setDisableFields(match.estados_globales !== ESTATUS_ACTIVO);
      setVisible(true);
      setIsEditing(true);
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);

      // Validar campos del formulario
      await formDireccion.validateFields();

      // Obtener todos los valores del formulario
      const values = {
        ...formDireccion.getFieldsValue(true),
        empleado: empleadoId,
      };

      // Agregar el ID del código postal si no está presente
      if (!values.codigo_postal && values.d_codigo) {
        const codigos = await getCodigosPostales({ d_codigo: values.d_codigo });
        const match = codigos.find((c) => c.d_codigo === values.d_codigo);
        if (match) {
          values.codigo_postal = match.id;
        }
      }

      // Normalizar los campos que pueden venir como objetos
      if (typeof values.tipo_de_direccion === 'object') {
        values.tipo_de_direccion = values.tipo_de_direccion?.id;
      }
      if (typeof values.tipo_de_vialidad === 'object') {
        values.tipo_de_vialidad = values.tipo_de_vialidad?.id;
      }
      if (typeof values.tipo_de_vialidad_entre === 'object') {
        values.tipo_de_vialidad_entre = values.tipo_de_vialidad_entre?.id;
      }
      if (typeof values.tipo_de_vialidad_y_calle === 'object') {
        values.tipo_de_vialidad_y_calle = values.tipo_de_vialidad_y_calle?.id;
      }

      // Formatear fecha de vigencia
      if (values.vigencia_final && values.vigencia_final.format) {
        values.vigencia_final = values.vigencia_final.format('YYYY-MM-DD');
      }

      // Validar que no exista otra dirección activa del mismo tipo sin fecha final
      const tipoId = values.tipo_de_direccion;
      const yaExisteActivo = (data?.results || []).some((item) => {
        const mismoTipo = item.tipo_de_direccion?.id === tipoId;
        const esActivo = item.estados_globales === ESTATUS_ACTIVO;
        const sinFin = !item.vigencia_final;
        const esOtroRegistro = !selectedRowKeys.includes(item.id);
        return mismoTipo && esActivo && sinFin && esOtroRegistro;
      });

      if (yaExisteActivo) {
        const tipoDescripcion = tiposDeDireccion.find((t) => t.id === tipoId)?.descripcion || 'seleccionado';
        message.warning(`Ya existe una dirección "${tipoDescripcion}" activa. Asigne una fecha de fin antes de guardar otra.`);
        setLoading(false);
        return;
      }

      // Enviar al backend (patch si es edición, post si es nuevo)
      const [key] = selectedRowKeys;
      const saved = await (key
        ? patchDireccion(key, values)
        : postDireccion(values));

      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel(); // cerrar modal y reset
          await fetchData();
        }
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteDireccion(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
    };

    formDireccion.setFieldsValue(dataForForm);
  };

  const handleKeyPress = (e) => {
    if (/\d/.test(e.key)) {
      e.preventDefault();
    }
  };
  const getTiposDeDireccionActuales = () => (
    (data?.results || [])
      .filter((item) => item.estados_globales === ESTATUS_ACTIVO)
      .map((item) => item.tipo_de_direccion?.id)
  );

  const existeDireccionActivaDelTipo = (tipoId) => {
    const existentes = data?.results || [];

    return existentes.some((item) => {
      const mismoTipo = item.tipo_de_direccion?.id === tipoId;
      const esActivo = item.estados_globales === ESTATUS_ACTIVO;
      const sinFin = !item.vigencia_final;

      return mismoTipo && esActivo && sinFin;
    });
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const tiposDeDireccionFiltrados = tiposDeDireccion.filter((tipo) => {
    const existentes = getTiposDeDireccionActuales();

    const TIPO_NO_APLICA = 1;
    const TIPO_PERSONAL = 3;
    const TIPO_FISCAL_Y_PERSONAL = 4;
    const TIPO_FISCAL = 5;

    const yaTieneFiscal = existentes.includes(TIPO_FISCAL);
    const yaTienePersonal = existentes.includes(TIPO_PERSONAL);
    const yaTieneAmbos = existentes.includes(TIPO_FISCAL_Y_PERSONAL);
    const yaTieneNoAplica = existentes.includes(TIPO_NO_APLICA);

    if (yaTieneAmbos) {
    // Si ya tiene "FISCAL Y PERSONAL", no se debe permitir ninguno más
      return tipo.id === TIPO_FISCAL_Y_PERSONAL;
    }

    if (yaTieneFiscal || yaTienePersonal) {
    // Si ya tiene FISCAL o PERSONAL, no se muestra NO APLICA ni FISCAL Y PERSONAL
      return ![TIPO_NO_APLICA, TIPO_FISCAL_Y_PERSONAL].includes(tipo.id);
    }

    if (yaTieneNoAplica) {
    // Si ya tiene NO APLICA, no permite ninguno más
      return tipo.id === TIPO_NO_APLICA;
    }

    // Por defecto permite todos
    return true;
  });

  const onClickAdd = () => {
    formDireccion.resetFields(); // ← limpia los campos del formulario
    form.resetFields(); // ← opcional si usas otro form secundario
    onCancel(); // ← cierra modales previos
    setVisible(true); // ← abre el modal para agregar
    setIsEditing(false); // ← marca que NO es edición
  };

  const onClickDelete = () => {
    const [key] = selectedRowKeys;
    if (key) {
      setVisibleAlert(true);
    } else {
      setVisibleAlert(false);
      message.warn('Este campo no se puede borrar');
    }
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;

      if (!key) {
        setLoading(false);
        setConfirmationVisible(false);
        message.warn('No se ha seleccionado ninguna dirección para autorizar');
        return;
      }

      // Consumimos tu API correcta
      const saved = await autorizarDireccion(key);

      if (saved) {
        // Refrescamos los datos de la tabla para que cambie el estatus a autorizado
        await fetchData();
        setConfirmationVisible(false);
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      titleText: 'Tipo de Dirección',
      dataIndex: 'tipo_de_direccion',
      key: 'tipo_de_direccion',
      width: 120,
      render: (val) => val?.descripcion || 'sin tipo',
    },
    {
      titleText: 'País',
      dataIndex: ['codigo_postal', 'municipio', 'estado', 'pais'],
      key: 'pais',
      width: 100,
      render: () => 'México', // si no viene en la API, se puede poner estático
    },
    {
      titleText: 'Estado',
      dataIndex: ['codigo_postal', 'municipio', 'estado', 'descripcion'],
      key: 'estado',
      width: 100,
      render: (_, record) => record?.codigo_postal?.municipio?.estado?.descripcion || '',
    },
    {
      titleText: 'Municipio',
      dataIndex: ['codigo_postal', 'municipio', 'descripcion'],
      key: 'municipio',
      width: 100,
      render: (_, record) => record?.codigo_postal?.municipio?.descripcion || '',
    },
    {
      titleText: 'Colonia',
      dataIndex: 'colonia',
      key: 'colonia',
      width: 120,
    },
    {
      titleText: 'Código Postal',
      dataIndex: ['codigo_postal', 'd_codigo'],
      key: 'd_codigo',
      width: 100,
      render: (_, record) => record?.codigo_postal?.d_codigo || record?.empleado?.codigo_postal || '',
    },
    {
      titleText: 'Número Exterior',
      dataIndex: 'numero_exterior',
      key: 'numero_exterior',
      width: 100,
    },
    {
      titleText: 'Número Interior',
      dataIndex: 'numero_interior',
      key: 'numero_interior',
      width: 100,
    },
    {
      titleText: 'Tipo de Vialidad',
      dataIndex: 'tipo_de_vialidad',
      key: 'tipo_de_vialidad',
      width: 120,
      render: (val) => tiposDeVialidades.find((v) => v.id === val)?.descripcion || '',
    },
    {
      titleText: 'Vialidad',
      dataIndex: 'calle_principal',
      key: 'calle_principal',
      width: 120,
    },
    {
      titleText: 'Tipo de Vialidad Entre',
      dataIndex: 'tipo_de_vialidad_entre',
      key: 'tipo_de_vialidad_entre',
      width: 120,
    },
    {
      titleText: 'Entre Vialidad',
      dataIndex: 'entre_calle',
      key: 'entre_calle',
      width: 120,
    },
    {
      titleText: 'Tipo de Vialidad Y Calle',
      dataIndex: 'tipo_de_vialidad_y_calle',
      key: 'tipo_de_vialidad_y_calle',
      width: 120,
    },
    {
      titleText: 'Y Vialidad',
      dataIndex: 'y_calle',
      key: 'y_calle',
      width: 120,
    },
    {
      titleText: 'Descripción de la Ubicación',
      dataIndex: 'descripcion_de_la_ubicacion',
      key: 'descripcion_de_la_ubicacion',
      width: 180,
    },
    {
      titleText: 'Vigencia',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 100,
      render: (vigencia) => (vigencia ? new Date(vigencia).toLocaleDateString() : 'Sin fecha'),
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 160,
      render: (_, record) => {
        if (!record.calle_principal || !record.colonia) {
          return 'Falta registrar una Dirección';
        }
        return record.observaciones || '';
      },
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  //   const rules = {
  //     required: [requiredRule],
  //     nombre: [
  //       requiredRule,
  //       {
  //         pattern: NOMBRES_PATTERN,
  //         message: 'Ingrese un nombre válido',
  //       },
  //     ],
  //   };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          data={data?.results || []}
          pagination={false}
          paginationCallback={fetchPaginated}
          count={data?.count || 0}
          cols={columns}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          customActions={[
            {
              onClick: () => setConfirmationVisible(true),
              permission: { model: 'empleadodomicilios', action: 'autorizar' },
              text: 'Autorizar',
              icon: <CheckCircleOutlined />,
              disabledBySelection: false,
              className: 'success',
            },
          ]}
          disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
          permission={permission}
          allowExportPDF={false}
        />

        <Modal
          width="80%"
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Dirección`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disableFields}
            />
        )}
          onCancel={onCancel}
        >
          <Form form={formDireccion} layout="vertical" onFinish={onFinish}>
            <Form.Item name="id" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="codigo_postal" hidden>
              <Input />
            </Form.Item>

            <Row gutter={10}>
              <Col span={24}>
                <Form.Item>
                  <LecturaDeDocumento
                    tipo="DOMICILIO"
                    texto="Leer Domicilio de INE, Constancia o Comprobante"
                    disabled={disableFields || isBlocked}
                    onDatos={(domicilio) => aplicarDomicilioExacto({
                      domicilio, form: formDireccion, tiposDeVialidades, setColonias,
                    })}
                  />
                </Form.Item>
              </Col>
              {/* Código Postal */}
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Código Postal" required style={{ marginBottom: 0 }}>
                  <Input.Group compact style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Item
                      name="d_codigo"
                      noStyle
                      rules={rules.required}
                    >
                      <Input
                        style={{ flex: 1, marginRight: 8 }}
                        maxLength={5}
                        onChange={(e) => {
                          const { value } = e.target;
                          if (value.length === 5) getFromPostalCode(value);
                        }}
                      />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => setVisibleNoSeCodigo(true)}
                      className="primary-on-hover"
                      style={{ padding: 0, minWidth: 0 }}
                    >
                      No sé mi código
                    </Button>
                  </Input.Group>
                </Form.Item>
              </Col>

              {/* Tipo de Dirección */}
              <Col xs={24} sm={24} md={16}>
                <Row gutter={8} align="middle" style={{ width: '100%' }}>
                  <Col xs={24} sm={12} md={12}>
                    <Form.Item
                      name="tipo_de_direccion"
                      label="Tipo de Dirección"
                      hasFeedback
                      style={{ width: '100%' }}
                      rules={rules.required}
                    >
                      <Select
                        labelProp="descripcion"
                        keyProp="id"
                        dataSource={tiposDeDireccionFiltrados}
                      />
                    </Form.Item>
                  </Col>
                  {isEditing && (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="vigencia_final"
                      label="Fecha de Fin (Vigencia)"
                      hasFeedback
                    >
                      <DatePicker
                        format="YYYY-MM-DD"
                        style={{ width: '100%' }}
                        placeholder="Seleccione una fecha"
                      />
                    </Form.Item>
                  </Col>
                  )}
                </Row>
              </Col>

              {/* País, Estado, Municipio */}
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="pais_codigo_postal"
                  label="País"
                  hasFeedback
                >
                  <Select
                    labelProp="nombre"
                    dataSource={paises}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item name="estado" label="Estado" hasFeedback>
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="municipio"
                  label="Municipio"
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled
                  />
                </Form.Item>
              </Col>

              {/* Colonia */}
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="colonia"
                  label="Colonia"
                  hasFeedback
                  rules={[{ required: true, message: 'Seleccione una colonia' }]} // Agrega validación si es necesario
                >
                  <Select
                    valueProp="colonia"
                    labelProp="colonia"
                    keyProp="id"
                    dataSource={colonias}
                    // disabled={isBlocked}
                    onChange={(val) => {
                      // Lógica para vincular el ID correcto cuando el usuario selecciona
                      if (val) {
                        const seleccionada = colonias.find((c) => c.colonia === val);
                        if (seleccionada) {
                          // Actualizamos el campo oculto 'codigo_postal' con el ID real
                          formDireccion.setFieldValue('codigo_postal', seleccionada.id);
                        }
                      } else {
                        // Si limpia el campo
                        formDireccion.setFieldsValue({ colonia: null, codigo_postal: null });
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              {/* Número exterior/interior */}
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="numero_exterior"
                  label="Número Exterior"
                  hasFeedback
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="numero_interior"
                  label="Número Interior"
                  hasFeedback
                >
                  <Input allowClear />
                </Form.Item>
              </Col>

              {/* Calle principal */}
              <Col xs={24} sm={24} md={8}>
                <Input.Group style={{ display: 'flex' }} compact>
                  <Form.Item
                    style={{ width: 150 }}
                    name="tipo_de_vialidad"
                    label="Tipo"
                    hasFeedback
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={tiposDeVialidades}
                    />
                  </Form.Item>
                  <Form.Item
                    style={{ width: '100%' }}
                    name="calle_principal"
                    label="Vialidad"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Input allowClear />
                  </Form.Item>
                </Input.Group>
              </Col>

              {/* Entre calle */}
              <Col xs={24} sm={24} md={8}>
                <Input.Group style={{ display: 'flex' }} compact>
                  <Form.Item
                    style={{ width: 150 }}
                    name="tipo_de_vialidad_entre"
                    label="Tipo"
                    hasFeedback
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={tiposDeVialidades}
                    />
                  </Form.Item>
                  <Form.Item
                    style={{ width: '100%' }}
                    name="entre_calle"
                    label="Entre Vialidad"
                    hasFeedback
                  >
                    <Input allowClear />
                  </Form.Item>
                </Input.Group>
              </Col>

              {/* Y calle */}
              <Col xs={24} sm={24} md={8}>
                <Input.Group style={{ display: 'flex' }} compact>
                  <Form.Item
                    style={{ width: 150 }}
                    name="tipo_de_vialidad_y_calle"
                    label="Tipo"
                    hasFeedback
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={tiposDeVialidades}
                    />
                  </Form.Item>
                  <Form.Item
                    style={{ width: '100%' }}
                    name="y_calle"
                    label="Y Vialidad"
                    hasFeedback
                  >
                    <Input allowClear />
                  </Form.Item>
                </Input.Group>
              </Col>

              {/* Descripción ubicación */}
              <Col span={24}>
                <Form.Item
                  name="descripcion_de_la_ubicacion"
                  label="Descripción de la Ubicación"
                  hasFeedback
                >
                  <Input.TextArea
                    autoSize={{ minRows: 2, maxRows: 3 }}
                    maxLength={250}
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>

          <ModalSearch
            callback={onFinishSearch}
            setVisible={setVisibleNoSeCodigo}
            open={visibleNoSeCodigo}
          />
        </Modal>

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={selectedData?.tipo_de_direccion?.descripcion || ''}
          loading={loading}
        />

        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setConfirmationVisible(false)}
          open={confirmationVisible}
          contentTitle={`¿Autorizar la dirección "${selectedData?.tipo_de_direccion?.descripcion || ''}"?`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default Direcciones;
